import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from './Avatar/Avatar.jsx';
import LanguageSelector from './LanguageSelector.jsx';
import { PageTitle } from './PageTitle.jsx';

import { useApplication } from '../AppContext';

const imgStyle = {
	height: '100px',
};

const avatarWrapperStyle = {
	display: 'inline-block',
	margin: '0 0 5px 0',
};

const Profile = () => {

	const { t } = useTranslation();
	const app = useApplication();
	const [name, setName] = React.useState(app?.userdata?.name ?? '');

	const updateStoredName = React.useCallback((newName) => {
		if (app?.userdata && newName !== app.userdata.name) {
			app.userdata.name = newName;
			app.save();
		}
	}, [app]);

	const handleNameChange = React.useCallback((e) => {
		const newName = e.target.value;
		setName(newName);
		updateStoredName(newName);
	}, [updateStoredName]);

	const handleAvatarClick = React.useCallback((e) => {
		e?.stopPropagation?.();
		e?.preventDefault?.();
		app.navigate('Avatar');
	}, [app]);

	const [showConfirm, setShowConfirm] = React.useState(false);

	const handleResetClick = React.useCallback(() => {
		setShowConfirm(true);
	}, []);

	const handleConfirmReset = React.useCallback(() => {
		setShowConfirm(false);
		app.resetStats();
		app.navigate('MainMenu');
	}, [app]);

	const handleCancelReset = React.useCallback(() => {
		setShowConfirm(false);
	}, []);

	const languageSection = React.useMemo(() => {
		return (
			<div>
				<label>
					{t('Language')}
				</label>
				<LanguageSelector />
			</div>
		);
	}, [t]);

	return (
		<div id="Profile" className="page profile">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('Profile')}</h1>
				</PageTitle>
				<div
					className="avatar"
					style={avatarWrapperStyle}
				>
					<label>{t('Avatar')}</label>

					<Avatar
						id="imgAvatar"
						avatar={app?.userdata?.avatar}
						style={imgStyle}
					/>
					<a
						onClick={handleAvatarClick}
						className="simpleButtonOutLine"
					>
						{t('Change')}
					</a>
				</div>
				<div>
					<label>
						{t('Name')}
					</label>
					<input
						placeholder={t('Name')}
						value={name}
						onChange={handleNameChange}
						type="text"
					/>
				</div>
				<div>
					<label>
						{t('Language')}
					</label>
					<LanguageSelector />
				</div>
				<div>
					<label>
						{t('Reset Stats')}
					</label>
					<a className="simpleButtonOutLine " onClick={handleResetClick}>
						{t('Reset')}
					</a>
					{showConfirm && (
						<div className="confirm-dialog">
							<p>{t('Are you sure you want to reset your stats?')}</p>
							<a className="simpleButtonOutLine" onClick={handleConfirmReset}>{t('Yes')}</a>
							<a className="simpleButtonOutLine" onClick={handleCancelReset}>{t('No')}</a>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Profile;
